// Información de los combos parrilleros de Su Carne.
// Este archivo contiene los datos que alimentan la sección de productos.

const combos = [
  {
    id: 'evento',
    name: 'Combo Evento',
    persons: '10-12 personas',
    price: 89990,
    description: 'Especial para reuniones y eventos de gran porte, con cortes de carne variados y achuras.',
    items: [
      '3 kg asado de vacuno',
      '2 kg asado de vacío',
      '1 colita de cuadril o picaña',
      '2 kg chorizos artesanales',
      'Mollejas',
      'Chinchulín / tripa gorda'
    ],
    slug: 'evento'
  },
  {
    id: 'amigos',
    name: 'Combo Amigos',
    persons: '6-8 personas',
    price: 59990,
    description: 'Ideal para compartir entre amigos. Incluye costilla, vacío, chorizos y achuras.',
    items: [
      '1.5 kg asado de costilla',
      '1.5 kg asado de vacío',
      '1 colita de cuadril o picaña',
      '1 kg chorizos artesanales',
      '1 kg achuras a elección'
    ],
    slug: 'amigos'
  },
  {
    id: 'familiar',
    name: 'Combo Familiar',
    persons: '4-6 personas',
    price: 39990,
    description: 'Pensado para la familia, con cortes tiernos, chorizos y queso.',
    items: [
      '1.5 kg asado de tira',
      '1 kg vacío',
      '1 kg chorizos artesanales',
      '2 morcillas',
      '2 piezas de chorizo seco',
      '1 kg queso Colonia'
    ],
    slug: 'familiar'
  },
  {
    id: 'premium',
    name: 'Combo Premium',
    persons: '7-9 personas',
    price: 79990,
    description: 'Para los paladares exigentes: cortes premium, cordero y chorizos.',
    items: [
      '1.5 kg ojo de bife o bife ancho',
      '1 picaña o colita de cuadril',
      '12 chorizos artesanales',
      '1 kg cordero (costillar)',
      '2 kg vacío de ternera con hueso'
    ],
    slug: 'premium'
  }
];

export default combos;